import React, { useState, useEffect, useContext } from 'react'
import { JsonForms } from '@jsonforms/react'
import { materialRenderers, materialCells } from '@jsonforms/material-renderers'
import { DesignContext } from 'contexts/DesignContext'

const CustomElement = (props) => {
  let { data, schema, uischema, handleChange, path, fieldName, fieldKey } =
    props
  const renderers = [...materialRenderers]
  const designContext = useContext(DesignContext)
  const { jsonForm, findSchema } = designContext

  const [currentSchema, setCurrentSchema] = useState({})

  useEffect(() => {
    if (uischema.key) {
      let mapName = jsonForm.schema.mapName[uischema.key]
      let nameList = mapName.split('.')
      if (schema && schema.properties) {
        let newSchema = findSchema(schema.properties, nameList)
        setCurrentSchema(newSchema)
      } else {
        setCurrentSchema(schema)
      }
    }
  }, [path])

  return (
    <JsonForms
      schema={currentSchema}
      uischema={uischema}
      data={data && path && data[path]}
      renderers={renderers}
      cells={materialCells}
      onChange={({ data, errors }) => {
        if (path && data) {
          handleChange(path, data[path])
        }
      }}
    />
  )
}
export default CustomElement
